exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".course-app .favor-button {\n  cursor: pointer;\n  font-size: 1.8em;\n}\n.course-app .favor-button:disabled {\n  cursor: default;\n}\n", ""]);
